var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3FCEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 52.6099L47.0121 45.5976C50.8848 41.725 50.8848 35.4461 47.0121 31.5734C43.1395 27.7007 36.8606 27.7007 32.9879 31.5734C29.1152 35.4461 29.1152 41.725 32.9879 45.5976L40 52.6099ZM40 56.6168L30.9844 47.6012C26.0052 42.6219 26.0052 34.5491 30.9844 29.57C35.9636 24.5908 44.0364 24.5908 49.0157 29.57C53.9948 34.5491 53.9948 42.6219 49.0157 47.6012L40 56.6168ZM40 41.4189C41.5648 41.4189 42.8333 40.1504 42.8333 38.5856C42.8333 37.0208 41.5648 35.7522 40 35.7522C38.4352 35.7522 37.1667 37.0208 37.1667 38.5856C37.1667 40.1504 38.4352 41.4189 40 41.4189ZM40 44.2522C36.8704 44.2522 34.3333 41.7151 34.3333 38.5856C34.3333 35.456 36.8704 32.9189 40 32.9189C43.1296 32.9189 45.6667 35.456 45.6667 38.5856C45.6667 41.7151 43.1296 44.2522 40 44.2522Z",
    fill: "#7ED957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinLine);
export default __webpack_public_path__ + "static/media/map-pin-line.5f792c651f6403eda220bcc57c7bb245.svg";
export { ForwardRef as ReactComponent };